import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  height: 100vh;
  flex-direction: column;
`;

export const ContainerInner = styled.div`
  flex: 1;
  padding: 16px;
  overflow: auto;
`;
